/** @jsxImportSource @emotion/react */
import React, { useCallback, useEffect, useState } from 'react'
import { debounce } from 'lodash'
import { DEBOUNCE_DELAY } from 'constants/consts'
import Input from 'components/Input'
import { MAX_TAKE_COUNT, MIN_TAKE_COUNT } from 'hooks/useQueryWithParams'
import * as classes from './styles'

export type PaginationTakeProps = {
  take: number
  onTakeChange: (take: number) => void
  className?: string
}

export const PaginationTake = ({ take, onTakeChange, className }: PaginationTakeProps) => {
  const [inputValue, setInputValue] = useState(String(take))
  const inputNumber = Math.round(+inputValue)
  const isInvalid =
    isNaN(+inputValue) || !inputValue.match(/^\d*$/) || inputNumber < MIN_TAKE_COUNT || inputNumber > MAX_TAKE_COUNT

  useEffect(() => {
    setInputValue(String(take))
  }, [take])

  const debouncedOnChange = useCallback(debounce(onTakeChange, DEBOUNCE_DELAY), [onTakeChange])

  const handleBlur = useCallback(() => {
    if (isInvalid || inputNumber === take) {
      return
    }

    debouncedOnChange(inputNumber)
  }, [take, isInvalid, inputNumber, debouncedOnChange])

  return (
    <div css={classes.takeWrapper} className={className}>
      <span>Number of items per page:</span>
      <Input
        value={inputValue}
        onChange={setInputValue}
        onBlur={handleBlur}
        error={isInvalid}
        placeholder={String(take)}
      />
    </div>
  )
}
